<template>
  <div>
    <!--    <v-card elevation="0" fixed tile>-->
    <!--      <v-app-bar flat color="rgb(255, 255, 255)">-->
    <!--        <v-toolbar-title class="pl-0 header-area">-->
    <!--          <v-btn fab text x-small color="black" @click="goBack">-->
    <!--            <v-icon size="24">mdi-arrow-left</v-icon>-->
    <!--          </v-btn>-->
    <!--          <span class="align-self-center header-title">일정</span>-->
    <!--        </v-toolbar-title>-->
    <!--        <v-spacer />-->
    <!--      </v-app-bar>-->
    <!--    </v-card>-->
    <!--v-row class="title-wrap" fixed>
      <v-col cols="12" class="pa-4 header-area">
        <v-btn fab text x-small color="black" @click="goBack">
          <v-icon size="24">mdi-arrow-left</v-icon>
        </v-btn>
        <span class="align-self-center header-title">일정</span>
      </v-col>
    </v-row-->

    <!-- 캘린더 -->
    <calendar class="overflow-y-auto overflow-x-hidden"></calendar>
  </div>
</template>

<script>
/* 일정 */
import Calendar from '@/components/calendar/Calendar.vue';
import routerConstants from '@/const/routerConstants';

export default {
  data: () => ({}),
  components: {
    Calendar,
  },

  methods: {
    goBack() {
      this.$router.push({ name: routerConstants.Main });
      //this.$router.go(-1);
    },
  },
};
</script>

<style>
/* #create .v-speed-dial {
  position: absolute;
}
.v-calendar-weekly__head .v-past,
.v-calendar-weekly__head .v-future,
.v-calendar-weekly__head .v-present {
  border-bottom: 1px solid #e0e0e0;
}*/
.v-application .v-present .primary {
  background-color: #3cb149 !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {
  /* margin-right: -1px; */
  margin-right: 0 !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__day {
  overflow: visible;
  /* margin-right: -1px; */
  margin-right: 0 !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday:last-child,
.v-calendar.v-calendar-events .v-calendar-weekly__day:last-child {
  margin-right: -1px !important;
}

.v-application .v-calendar-monthly .v-calendar-weekly__day-label {
  margin: 2px 0 !important;
}
/* 달력 내부 원 사이즈 */
.v-application .v-calendar-monthly .v-size--small {
  width: 34px;
  height: 34px;
}
.v-speed-dial--right {
  right: 24px !important;
}
.v-speed-dial--bottom {
  bottom: 86px !important;
}
</style>
